import React from 'react';

import SelectFilter from 'components/search_sidebar/select_filter';

import type { Filters } from './types';

const scheduledOption = { label: 'Scheduled Tasks', value: 'scheduled' };
const tbdOption = { label: 'Unscheduled Tasks', value: 'tbd' };
const allOption = { label: 'All Tasks', value: 'all_tasks' };

type Slice = Pick<Filters, 'tbd' | 'allTasks'>;
interface Props extends Slice {
  onChange: (changes: Slice) => void;
}

// eslint-disable-next-line react/prop-types
export default function TasksIndexFilters({ tbd, allTasks, onChange }: Props) {
  const handleChange = ({ value }: { value: string }) => {
    if (value === 'scheduled') {
      onChange({ tbd: null, allTasks: null });
    } else if (value === 'tbd') {
      onChange({ tbd: true, allTasks: null });
    } else {
      onChange({ tbd: null, allTasks: true });
    }
  };

  const getValue = () => {
    if (allTasks) return allOption;
    if (tbd) return tbdOption;
    return scheduledOption;
  };

  return (
    <SelectFilter
      autoWidth
      options={[scheduledOption, tbdOption, allOption]}
      value={getValue()}
      onChange={handleChange}
    />
  );
}
